'use client';

import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  z-index: 9999 !important; //default z-index is 1000 for antd modal, drawer etc. The loader should have the biggest z-index.
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  background-color: ${({ theme }) => theme.palette.darkGrey};
  opacity: 0.8;

  align-items: center;
  justify-content: center;
`;
export const Wrapper = styled.div`
  max-width: 380px;
  margin-bottom: 15px;
  text-align: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    width: 224px;
  }
`;
export const Text = styled.span<{ fontSize?: number }>`
  font-weight: bold;

  color: ${({ theme }) => theme.palette.white};
  font-size: ${({ fontSize }) => `${fontSize}px`};
  display: flex;
  justify-content: center;
`;

export const SubText = styled(Text)<{ fontSize?: number }>`
  font-size: ${({ fontSize }) => `${fontSize}px`};
`;
